module.exports = __webpack_public_path__ + "static/media/table.6425affe.png";